"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscolaLMSContextProvider = exports.getCalcCourseProgress = exports.sortProgram = exports.getDefaultData = exports.EscolaLMSContext = exports.SCORMPlayer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var consultations_access_enquiry_1 = require("./consultations_access_enquiry");
var courses_1 = require("./courses");
var dictionariesWords_1 = require("./dictionary/dictionariesWords");
var dictionariesWord_1 = require("./dictionary/dictionariesWord");
var dictionariesAccess_1 = require("./dictionary/dictionariesAccess");
var dictionariesWordsCategories_1 = require("./dictionary/dictionariesWordsCategories");
var states_1 = require("./states");
var courses_2 = require("./../../services/courses");
var consultations_1 = require("./../../services/consultations");
var products_1 = require("../../services/products");
var webinars_1 = require("../../services/webinars");
var events_1 = require("../../services/events");
var settings_1 = require("./../../services/settings");
var certificates_1 = require("../../services/certificates");
var mattermost_1 = require("../../services/mattermost");
var cart_1 = require("./../../services/cart");
var user_groups_1 = require("./../../services/user_groups");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var API = __importStar(require("./../../types/api"));
var defaults_1 = require("./defaults");
var fields_1 = require("../../services/fields");
var stationary_events_1 = require("../../services/stationary_events");
var courses_3 = require("./courses");
var categories_1 = require("./categories");
var tags_1 = require("./tags");
var tutors_1 = require("./tutors");
var webinars_2 = require("./webinars");
var webinar_1 = require("./webinar");
var h5p_1 = require("./h5p");
var pages_1 = require("./pages");
var page_1 = require("./page");
var consultations_2 = require("./consultations");
var user_1 = require("./user");
var tasks_1 = require("./tasks");
var task_1 = require("./task");
var course_access_1 = require("./course_access");
var consultations_access_1 = require("./consultations_access");
var notifications_1 = require("./notifications");
var bookmark_notes_1 = require("./bookmark_notes");
var cart_2 = require("./cart");
var questionnaires_1 = require("./questionnaires");
var subjects_1 = require("./subjects");
var schedule_1 = require("./schedule");
var subjectsTutors_1 = require("./subjectsTutors");
var attendances_1 = require("./attendances");
var exams_1 = require("./exams");
var chat_1 = require("../../services/student/chat");
var studentDetails_1 = require("./studentDetails");
var challenges_1 = require("./challenges");
var course_1 = require("../../utils/course");
var SCORMPlayer = function (_a) {
    var uuid = _a.uuid;
    var apiUrl = (0, react_1.useContext)(exports.EscolaLMSContext).apiUrl;
    return (0, jsx_runtime_1.jsx)("iframe", { src: "".concat(apiUrl, "/api/scorm/play/").concat(uuid) });
};
exports.SCORMPlayer = SCORMPlayer;
exports.EscolaLMSContext = react_1.default.createContext(defaults_1.defaultConfig);
var getDefaultData = function (key, initialValues) {
    return initialValues[key];
};
exports.getDefaultData = getDefaultData;
var sortProgram = function (lessons) {
    return __spreadArray([], lessons, true).sort(function (lessonA, lessonB) {
        return typeof lessonA.order === "number" && typeof lessonB.order === "number"
            ? lessonA.order - lessonB.order
            : 0;
    })
        .map(function (lesson) { return (__assign(__assign({}, lesson), { topics: __spreadArray([], (lesson.topics || []), true).sort(function (topicA, topicB) {
            return typeof topicA.order === "number" && typeof topicB.order === "number"
                ? topicA.order - topicB.order
                : 0;
        }) })); });
};
exports.sortProgram = sortProgram;
var getCalcCourseProgress = function (courseId, progress, courseProgressDetails) {
    var _a;
    if (courseProgressDetails &&
        courseProgressDetails.byId &&
        courseProgressDetails.byId[Number(courseId)] &&
        courseProgressDetails.byId[Number(courseId)].value) {
        return courseProgressDetails.byId[Number(courseId)].value;
    }
    return (progress &&
        progress.value &&
        ((_a = progress.value.find(function (courseProgress) {
            return courseProgress.course.id === Number(courseId);
        })) === null || _a === void 0 ? void 0 : _a.progress));
    // eslint-disable-next-line react-hooks/exhaustive-deps
};
exports.getCalcCourseProgress = getCalcCourseProgress;
/**
 *
 * @component
 */
var EscolaLMSContextProviderInner = function (_a) {
    var children = _a.children, apiUrl = _a.apiUrl, defaults = _a.defaults, _b = _a.imagePrefix, imagePrefix = _b === void 0 ? "".concat(apiUrl, "/storage/imgcache") : _b, _c = _a.imageSvgPrefix, imageSvgPrefix = _c === void 0 ? "".concat(apiUrl, "/storage") : _c, _d = _a.initialFetch, initialFetch = _d === void 0 ? true : _d, _e = _a.ssrHydration, ssrHydration = _e === void 0 ? false : _e;
    // interceptors(apiUrl);
    var initialValues = __assign(__assign({}, defaults_1.defaultConfig), defaults);
    var getImagePrefix = function () { return imagePrefix; };
    // Prefix for svg files
    // Default: `${apiUrl}/storage`
    var getImageSvgPrefix = function () { return imageSvgPrefix; };
    var _f = (0, react_1.useContext)(user_1.UserContext), token = _f.token, user = _f.user, socialAuthorize = _f.socialAuthorize, changePassword = _f.changePassword, deleteAccount = _f.deleteAccount, login = _f.login, logoutUser = _f.logout, forgot = _f.forgot, reset = _f.reset, fetchProfile = _f.fetchProfile, updateProfile = _f.updateProfile, updateProfileEmail = _f.updateProfileEmail, updateAvatar = _f.updateAvatar, getRefreshedToken = _f.getRefreshedToken, emailVerify = _f.emailVerify, tokenExpireDate = _f.tokenExpireDate, register = _f.register, initAccountDelete = _f.initAccountDelete, confirmAccountDelete = _f.confirmAccountDelete;
    var _g = (0, react_1.useContext)(cart_2.CartContext), cart = _g.cart, fetchCart = _g.fetchCart, addToCart = _g.addToCart, removeFromCart = _g.removeFromCart, addMissingProducts = _g.addMissingProducts, resetCart = _g.resetCart;
    var _h = (0, react_1.useContext)(courses_1.CoursesContext), courses = _h.courses, fetchCourses = _h.fetchCourses;
    var _j = (0, react_1.useContext)(categories_1.CategoriesContext), categoryTree = _j.categoryTree, fetchCategories = _j.fetchCategories;
    var _k = (0, react_1.useContext)(tags_1.TagsContext), uniqueTags = _k.uniqueTags, fetchTags = _k.fetchTags;
    var _l = (0, react_1.useContext)(tutors_1.TutorsContext), tutors = _l.tutors, fetchTutors = _l.fetchTutors;
    var _m = (0, react_1.useContext)(webinars_2.WebinarsContext), webinars = _m.webinars, fetchWebinars = _m.fetchWebinars;
    var _o = (0, react_1.useContext)(webinar_1.WebinarContext), webinar = _o.webinar, fetchWebinar = _o.fetchWebinar;
    var _p = (0, react_1.useContext)(h5p_1.H5pContext), h5p = _p.h5p, fetchH5P = _p.fetchH5P;
    var _q = (0, react_1.useContext)(consultations_2.ConsultationsContext), consultations = _q.consultations, fetchConsultations = _q.fetchConsultations;
    var _r = (0, react_1.useContext)(pages_1.PagesContext), pages = _r.pages, fetchPages = _r.fetchPages;
    var _s = (0, react_1.useContext)(page_1.PageContext), page = _s.page, fetchPage = _s.fetchPage;
    var _t = (0, react_1.useContext)(tasks_1.TasksContext), tasks = _t.tasks, fetchTasks = _t.fetchTasks, addTask = _t.addTask, deleteTask = _t.deleteTask;
    var _u = (0, react_1.useContext)(task_1.TaskContext), task = _u.task, fetchTask = _u.fetchTask, updateTask = _u.updateTask, updateTaskStatus = _u.updateTaskStatus, createTaskNote = _u.createTaskNote, updateTaskNote = _u.updateTaskNote, deleteTaskNote = _u.deleteTaskNote;
    var _v = (0, react_1.useContext)(bookmark_notes_1.BookmarkNotesContext), bookmarkNotes = _v.bookmarkNotes, createBookmarkNote = _v.createBookmarkNote, updateBookmarkNote = _v.updateBookmarkNote, deleteBookmarkNote = _v.deleteBookmarkNote, fetchBookmarkNotes = _v.fetchBookmarkNotes;
    var _w = (0, react_1.useContext)(course_access_1.CourseAccessContext), courseAccess = _w.courseAccess, fetchCourseAccess = _w.fetchCourseAccess, addCourseAccess = _w.addCourseAccess, deleteCourseAccess = _w.deleteCourseAccess, myCourses = _w.myCourses, fetchMyCourses = _w.fetchMyCourses;
    var _x = (0, react_1.useContext)(challenges_1.ChallengesContext), fetchChallenges = _x.fetchChallenges, challenges = _x.challenges, challenge = _x.challenge, fetchChallenge = _x.fetchChallenge;
    var _y = (0, react_1.useContext)(consultations_access_enquiry_1.ConsultationsAccessEnquiryContext), fetchConsultationAccessEnquiry = _y.fetchConsultationAccessEnquiry, consultationAccessEnquiry = _y.consultationAccessEnquiry;
    var _z = (0, react_1.useContext)(consultations_access_1.ConsultationAccessContext), consultationAccess = _z.consultationAccess, fetchConsultationAccess = _z.fetchConsultationAccess, addConsultationAccess = _z.addConsultationAccess, deleteConsultationAccess = _z.deleteConsultationAccess, updateConsultationAccess = _z.updateConsultationAccess;
    var _0 = (0, react_1.useContext)(notifications_1.NotificationsContext), notifications = _0.notifications, fetchNotifications = _0.fetchNotifications, readNotify = _0.readNotify, readAllNotifications = _0.readAllNotifications;
    var _1 = (0, react_1.useContext)(questionnaires_1.QuestionnairesContext), fetchQuestionnaires = _1.fetchQuestionnaires, fetchQuestionnaire = _1.fetchQuestionnaire, fetchQuestionnairesAnswers = _1.fetchQuestionnairesAnswers, fetchQuestionnaireStars = _1.fetchQuestionnaireStars, sendQuestionnaireAnswer = _1.sendQuestionnaireAnswer, fetchQuestionnaireStarsByModel = _1.fetchQuestionnaireStarsByModel;
    var _2 = (0, react_1.useContext)(subjects_1.SubjectsContext), fetchSubjects = _2.fetchSubjects, subjects = _2.subjects;
    var _3 = (0, react_1.useContext)(schedule_1.ScheduleContext), fetchSchedule = _3.fetchSchedule, schedule = _3.schedule;
    var _4 = (0, react_1.useContext)(subjectsTutors_1.ScheduleTutorsContext), fetchScheduleTutors = _4.fetchScheduleTutors, scheduleTutors = _4.scheduleTutors;
    var _5 = (0, react_1.useContext)(attendances_1.AttendancesContext), fetchAttendances = _5.fetchAttendances, attendances = _5.attendances;
    var _6 = (0, react_1.useContext)(exams_1.ExamsContext), fetchExams = _6.fetchExams, exams = _6.exams;
    var _7 = (0, react_1.useContext)(studentDetails_1.StudentDetailsContext), fetchSemesters = _7.fetchSemesters, semesters = _7.semesters, fetchAcademicYears = _7.fetchAcademicYears, academicYears = _7.academicYears;
    var _8 = (0, react_1.useContext)(dictionariesWords_1.DictionariesWordsContext), dictionariesWords = _8.dictionariesWords, fetchDictionariesWords = _8.fetchDictionariesWords;
    var _9 = (0, react_1.useContext)(dictionariesWord_1.DictionariesWordContext), dictionariesWord = _9.dictionariesWord, fetchDictionariesWord = _9.fetchDictionariesWord;
    var _10 = (0, react_1.useContext)(dictionariesAccess_1.DictionariesAccessContext), dictionariesAccess = _10.dictionariesAccess, fetchDictionariesAccess = _10.fetchDictionariesAccess;
    var _11 = (0, react_1.useContext)(dictionariesWordsCategories_1.DictionariesWordsCategoriesContext), dictionariesWordsCategories = _11.dictionariesWordsCategories, fetchDictionariesWordsCategories = _11.fetchDictionariesWordsCategories;
    // https://github.com/EscolaLMS/sdk/issues/235
    // FIXME: #235 move consultation logic to separate file
    var _12 = (0, useLocalStorage_1.useLocalStorage)("lms", "consultation", (0, exports.getDefaultData)("consultation", initialValues), ssrHydration), consultation = _12[0], setConsultation = _12[1];
    var _13 = (0, useLocalStorage_1.useLocalStorage)("lms", "userConsultations", (0, exports.getDefaultData)("userConsultations", initialValues), ssrHydration), userConsultations = _13[0], setUserConsultations = _13[1];
    var _14 = (0, useLocalStorage_1.useLocalStorage)("lms", "tutorConsultations", (0, exports.getDefaultData)("tutorConsultations", initialValues), ssrHydration), tutorConsultations = _14[0], setTutorConsultations = _14[1];
    // Refactor Events. move logic to separate file
    // https://github.com/EscolaLMS/sdk/issues/237
    var _15 = (0, useLocalStorage_1.useLocalStorage)("lms", "events", (0, exports.getDefaultData)("events", initialValues), ssrHydration), events = _15[0], setEvents = _15[1];
    // Refactor UserGroups. move logic to separate file
    // https://github.com/EscolaLMS/sdk/issues/236
    var _16 = (0, useLocalStorage_1.useLocalStorage)("lms", "userGroup", (0, exports.getDefaultData)("userGroup", initialValues), ssrHydration), userGroup = _16[0], setUserGroup = _16[1];
    var _17 = (0, useLocalStorage_1.useLocalStorage)("lms", "userGroups", (0, exports.getDefaultData)("userGroups", initialValues), ssrHydration), userGroups = _17[0], setUserGroups = _17[1];
    var _18 = (0, useLocalStorage_1.useLocalStorage)("lms", "registerableGroups", (0, exports.getDefaultData)("registerableGroups", initialValues), ssrHydration), registerableGroups = _18[0], setRegisterableGroups = _18[1];
    // Refactor. Course & PRogram. Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/238
    var _19 = (0, useLocalStorage_1.useLocalStorage)("lms", "course", (0, exports.getDefaultData)("course", initialValues), ssrHydration), course = _19[0], setCourse = _19[1];
    var _20 = (0, useLocalStorage_1.useLocalStorage)("lms", "program", (0, exports.getDefaultData)("program", initialValues), ssrHydration), program = _20[0], setProgram = _20[1];
    // Refactor. Settings & Config. Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/239
    var _21 = (0, useLocalStorage_1.useLocalStorage)("lms", "settings", (0, exports.getDefaultData)("settings", initialValues), ssrHydration), settings = _21[0], setSettings = _21[1];
    var _22 = (0, useLocalStorage_1.useLocalStorage)("lms", "config", (0, exports.getDefaultData)("config", initialValues), ssrHydration), config = _22[0], setConfig = _22[1];
    // Refactor. Cart. Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/240
    var _23 = (0, react_1.useState)((0, exports.getDefaultData)("progress", initialValues)), progress = _23[0], setProgress = _23[1];
    var _24 = (0, react_1.useState)((0, exports.getDefaultData)("paginatedProgress", initialValues)), paginatedProgress = _24[0], setPaginatedProgress = _24[1];
    var _25 = (0, react_1.useState)((0, exports.getDefaultData)("myAuthoredCourses", initialValues)), myAuthoredCourses = _25[0], setMyAuthoredCourses = _25[1];
    var _26 = (0, react_1.useState)((0, exports.getDefaultData)("courseProgressDetails", initialValues)), courseProgressDetails = _26[0], setCourseProgressDetails = _26[1];
    // Refactor. Orders . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/242
    var _27 = (0, useLocalStorage_1.useLocalStorage)("lms", "orders", (0, exports.getDefaultData)("orders", initialValues), ssrHydration), orders = _27[0], setOrders = _27[1];
    // Refactor. Payments . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/243
    var _28 = (0, useLocalStorage_1.useLocalStorage)("lms", "payments", (0, exports.getDefaultData)("payments", initialValues), ssrHydration), payments = _28[0], setPayments = _28[1];
    // Refactor. Certificates . Move to separate file. Add new backend logic to generate
    // https://github.com/EscolaLMS/sdk/issues/244
    var _29 = (0, useLocalStorage_1.useLocalStorage)("lms", "certificates", (0, exports.getDefaultData)("certificates", initialValues), ssrHydration), certificates = _29[0], setCertificates = _29[1];
    // Refactor. Mattermost . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/245
    var _30 = (0, useLocalStorage_1.useLocalStorage)("lms", "mattermostChannels", (0, exports.getDefaultData)("mattermostChannels", initialValues), ssrHydration), mattermostChannels = _30[0], setMattermostChannels = _30[1];
    // Refactor. Tutor . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/246
    var _31 = (0, react_1.useState)((0, exports.getDefaultData)("tutor", initialValues)), tutor = _31[0], setTutor = _31[1];
    // Refactor. Metadata Fields . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/247
    var _32 = (0, useLocalStorage_1.useLocalStorage)("lms", "fields", (0, exports.getDefaultData)("fields", initialValues), ssrHydration), fields = _32[0], setFields = _32[1];
    // Refactor. Stationary Events . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/248
    var _33 = (0, useLocalStorage_1.useLocalStorage)("lms", "stationaryEvents", (0, exports.getDefaultData)("stationaryEvents", initialValues), ssrHydration), stationaryEvents = _33[0], setStationaryEvents = _33[1];
    var _34 = (0, useLocalStorage_1.useLocalStorage)("lms", "stationaryEvent", (0, exports.getDefaultData)("stationaryEvent", initialValues), ssrHydration), stationaryEvent = _34[0], setStationaryEvent = _34[1];
    var _35 = (0, useLocalStorage_1.useLocalStorage)("lms", "userStationaryEvents", (0, exports.getDefaultData)("userStationaryEvents", initialValues), ssrHydration), userStationaryEvents = _35[0], setUserStationaryEvents = _35[1];
    // Refactor. Webinars . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/249
    var _36 = (0, useLocalStorage_1.useLocalStorage)("lms", "userWebinars", (0, exports.getDefaultData)("userWebinars", initialValues), ssrHydration), userWebinars = _36[0], setUserWebinars = _36[1];
    // Refactor. Products . Move to separate file.
    // https://github.com/EscolaLMS/sdk/issues/250
    var _37 = (0, useLocalStorage_1.useLocalStorage)("lms", "products", (0, exports.getDefaultData)("products", initialValues), ssrHydration), products = _37[0], setProducts = _37[1];
    var _38 = (0, useLocalStorage_1.useLocalStorage)("lms", "userProducts", (0, exports.getDefaultData)("userProducts", initialValues), ssrHydration), userProducts = _38[0], setUserProducts = _38[1];
    var _39 = (0, useLocalStorage_1.useLocalStorage)("lms", "product", (0, exports.getDefaultData)("product", initialValues), ssrHydration), product = _39[0], setProduct = _39[1];
    var abortControllers = (0, react_1.useRef)({});
    // https://github.com/EscolaLMS/sdk/issues/239
    var fetchConfig = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "config",
            mode: "value",
            fetchAction: settings_1.config.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setConfig,
        });
    }, []);
    // https://github.com/EscolaLMS/sdk/issues/239
    var fetchSettings = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "settings",
            mode: "value",
            fetchAction: settings_1.settings.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setSettings,
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (initialFetch) {
            fetchSettings();
            fetchConfig();
        }
    }, [initialFetch]);
    // TODO: remove after refactor
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (defaults) {
            defaults.stationaryEvents !== null &&
                setStationaryEvents({
                    loading: false,
                    list: (_a = defaults.stationaryEvents) === null || _a === void 0 ? void 0 : _a.list,
                    error: undefined,
                });
            defaults.events !== null &&
                setEvents({
                    loading: false,
                    list: (_b = defaults.events) === null || _b === void 0 ? void 0 : _b.list,
                    error: undefined,
                });
        }
    }, [defaults]);
    // https://github.com/EscolaLMS/sdk/issues/250
    var fetchProducts = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "products/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: products_1.products.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["products/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setProducts,
        });
    }, []);
    var fetchMyProducts = (0, react_1.useCallback)(function (filter) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "products/my/".concat(JSON.stringify(filter)),
                mode: "paginated",
                fetchAction: products_1.getMyProducts.bind(null, apiUrl)(filter, token, {
                    signal: (_a = abortControllers.current["products/my/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setUserProducts,
            })
            : Promise.reject("noToken");
    }, [token]);
    var attachProduct = (0, react_1.useCallback)(function (productableId, productableType) {
        return token
            ? products_1.attachProduct
                .bind(null, apiUrl)(productableId, productableType, token)
                .catch(function (err) { return err; })
            : Promise.reject("noToken");
    }, [token]);
    var cancelSubscription = (0, react_1.useCallback)(function (productId) {
        return token
            ? products_1.cancelSubscripton
                .bind(null, apiUrl)(productId, token)
                .catch(function (err) { return err; })
            : Promise.reject("noToken");
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/250
    var fetchProduct = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "product".concat(id),
            id: id,
            mode: "value",
            fetchAction: products_1.getSingleProduct.bind(null, apiUrl)(id, token, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["product".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setProduct,
        });
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/247
    var fetchFields = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "fields/".concat(JSON.stringify(filter)),
            mode: "list",
            fetchAction: fields_1.fields.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["fields/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setFields,
        });
    }, []);
    // https://github.com/EscolaLMS/sdk/issues/248
    var fetchStationaryEvents = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "stationaryevents/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: stationary_events_1.stationaryEvents.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["stationaryevents/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setStationaryEvents,
        });
    }, []);
    // https://github.com/EscolaLMS/sdk/issues/248
    var fetchStationaryEvent = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "stationaryevent".concat(id),
            id: id,
            mode: "value",
            fetchAction: stationary_events_1.getStationaryEvent.bind(null, apiUrl)(id, token, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["stationaryevent".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setStationaryEvent,
        });
    }, []);
    // https://github.com/EscolaLMS/sdk/issues/249
    var fetchUserWebinars = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userwebinars",
                mode: "list",
                fetchAction: webinars_1.getMyWebinars.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userwebinars) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserWebinars,
            })
            : Promise.reject("noToken");
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/248
    var fetchUserStationaryEvents = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userstationaryevents",
                mode: "list",
                fetchAction: stationary_events_1.getMyStationaryEvents.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userstationaryevents) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserStationaryEvents,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchTutorConsultations = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "tutorconsultation",
                mode: "paginated",
                fetchAction: consultations_1.getTutorConsultations.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.tutorconsultation) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var approveConsultationTerm = (0, react_1.useCallback)(function (id, term, userId) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "aprovetutorterm".concat(id),
                mode: "paginated",
                fetchAction: consultations_1.approveConsultation.bind(null, apiUrl)(token, id, term, userId, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["aprovetutorterm".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var rejectConsultationTerm = (0, react_1.useCallback)(function (id, term, userId) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "rejectterm".concat(id),
                mode: "paginated",
                fetchAction: consultations_1.rejectConsultation.bind(null, apiUrl)(token, id, term, userId, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["rejectterm".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    // Refactor Jitsy. Move to separate file
    // https://github.com/EscolaLMS/sdk/issues/251
    var generateConsultationJitsy = (0, react_1.useCallback)(function (id, term) {
        return token
            ? consultations_1.generateJitsy.bind(null, apiUrl)(token, id, term)
            : Promise.reject("noToken");
    }, [token]);
    var generateWebinarJitsy = (0, react_1.useCallback)(function (id) {
        return token
            ? webinars_1.generateJitsyWebinar.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/244
    var fetchCertificates = (0, react_1.useCallback)(function (params) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "certificates/".concat(JSON.stringify(params)),
                mode: "paginated",
                fetchAction: certificates_1.getCertificates.bind(null, apiUrl)(token, params, {
                    signal: (_a = abortControllers.current["certificates/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setCertificates,
            })
            : Promise.reject("noToken");
    }, [token]);
    var createTeamsChat = (0, react_1.useCallback)(function (id) {
        return token
            ? (0, chat_1.postTeamsChat)(apiUrl, token, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchCertificate = (0, react_1.useCallback)(function (id) {
        return token
            ? certificates_1.getCertificate.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var generateCertificate = (0, react_1.useCallback)(function (id) {
        return token
            ? certificates_1.generateCertificatePdf.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchMattermostChannels = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "mattermostchannels",
                mode: "value",
                fetchAction: mattermost_1.getMattermostChannels.bind(null, apiUrl)(token, {}, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.mattermostchannels) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setMattermostChannels,
            })
            : Promise.reject("noToken");
    }, [token]);
    var changeConsultationTerm = (0, react_1.useCallback)(function (termId, newDate, term, userId) {
        return token
            ? consultations_1.changeTermDate.bind(null, apiUrl)(termId, newDate, term, token, userId)
            : Promise.reject("noToken");
    }, [token]);
    var fetchUserConsultations = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userconsultations",
                mode: "paginated",
                fetchAction: consultations_1.getUserConsultations.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userconsultations) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var bookConsultationTerm = (0, react_1.useCallback)(function (id, term) {
        return token
            ? consultations_1.bookConsultationDate
                .bind(null, apiUrl)(token, id, term)
                .then(function (response) {
                if (response.success) {
                    fetchUserConsultations();
                    return response;
                }
                throw Error("Error occured");
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchConsultation = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            id: id,
            controllers: abortControllers.current,
            controller: "consultation".concat(id),
            mode: "value",
            fetchAction: consultations_1.getConsultation.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["consultation".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setConsultation,
        });
    }, []);
    var getProductInfo = (0, react_1.useCallback)(function (id) {
        return token
            ? products_1.getSingleProduct.bind(null, apiUrl)(id, token)
            : Promise.reject("noToken");
    }, [token]);
    var fetchEvents = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "events/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: events_1.events.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["events/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setEvents,
        });
    }, []);
    var fetchUserGroup = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "usergroup".concat(id),
            id: id,
            mode: "value",
            fetchAction: user_groups_1.userGroup.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["usergroup".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setUserGroup,
        });
    }, []);
    var fetchRegisterableGroups = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "registablegroups",
            mode: "list",
            fetchAction: user_groups_1.registerableGroups.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.registablegroups) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setRegisterableGroups,
        });
    }, []);
    var fetchUserGroups = (0, react_1.useCallback)(function (params) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "getusergroups/".concat(JSON.stringify(params)),
            mode: "paginated",
            fetchAction: user_groups_1.userGroups.bind(null, apiUrl)(params, {
                signal: (_a = abortControllers.current["getusergroups/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setUserGroups,
        });
    }, []);
    var fetchCourse = (0, react_1.useCallback)(function (id) {
        setCourse(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { loading: true, byId: prevState.byId
                    ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = __assign(__assign({}, prevState.byId[id]), { loading: true }), _a)) : (_b = {}, _b[id] = { loading: true }, _b) }));
        });
        return courses_2.getCourse
            .bind(null, apiUrl)(id, token)
            .then(function (response) {
            if (response.success) {
                var lessons_1 = (0, exports.sortProgram)(response.data.lessons || []);
                setCourse(function (prevState) {
                    var _a, _b;
                    return ({
                        loading: false,
                        value: __assign(__assign({}, response.data), { lessons: lessons_1 }),
                        byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                value: response.data,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                value: response.data,
                                loading: false,
                            },
                            _b),
                    });
                });
            }
            if (response.success === false) {
                setCourse(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), { loading: false, error: response, byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                error: response,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                error: response,
                                loading: false,
                            },
                            _b) }));
                });
            }
            return response;
        });
    }, [token]);
    // TODO each context should have a separate `reset` method
    // https://github.com/EscolaLMS/sdk/issues/252
    var resetState = (0, react_1.useCallback)(function () {
        logoutUser();
        resetCart();
        setProgram(defaults_1.defaultConfig.program);
        setCertificates(defaults_1.defaultConfig.certificates);
        setMattermostChannels(defaults_1.defaultConfig.mattermostChannels);
        localStorage.removeItem("user");
        localStorage.removeItem("user_token");
        localStorage.removeItem("lms");
    }, [logoutUser]);
    var logout = (0, react_1.useCallback)(function () {
        // TODO this should be composition of contexts
        // API Call here to destroy token
        resetState();
        return Promise.resolve();
    }, []);
    var payWithStripe = (0, react_1.useCallback)(function (payment_method, return_url) {
        return token
            ? cart_1.payWithStripe
                .bind(null, apiUrl)(payment_method, return_url, token)
                .then(function (res) {
                console.log(res);
            })
            : Promise.reject("noToken");
    }, [token]);
    var payWithP24 = (0, react_1.useCallback)(function (email, return_url, data) {
        return token
            ? cart_1.payWithP24
                .bind(null, apiUrl)(email, return_url, token, data)
                .then(function (res) {
                return res;
            })
                .catch(function (err) {
                console.log(err);
                return err;
            })
            : Promise.reject("noToken");
    }, [token]);
    var subscriptionPayWithP24 = (0, react_1.useCallback)(function (subId, email, return_url, data) {
        return token
            ? cart_1.subscriptionPayWithP24
                .bind(null, apiUrl)(subId, email, return_url, token, data)
                .then(function (res) {
                return res;
            })
                .catch(function (err) {
                console.log(err);
                return err;
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchOrderInvoice = (0, react_1.useCallback)(function (id, options) {
        return token
            ? cart_1.orderInvoice.bind(null, apiUrl)(token, id, options)
            : Promise.reject("noToken");
    }, [token]);
    // TODO move this do separate file/context
    // https://github.com/EscolaLMS/sdk/issues/238
    var fetchProgram = (0, react_1.useCallback)(function (id) {
        setProgram(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { loading: true, byId: prevState.byId
                    ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = __assign(__assign({}, prevState.byId[id]), { loading: true }), _a)) : (_b = {}, _b[id] = { loading: true }, _b) }));
        });
        return courses_2.getCourseProgram
            .bind(null, apiUrl)(id, token)
            .then(function (response) {
            if (response.success) {
                var sortedLessons_1 = (0, exports.sortProgram)(response.data.lessons);
                setProgram(function (prevState) {
                    var _a, _b;
                    return ({
                        loading: false,
                        value: __assign(__assign({}, response.data), { lessons: sortedLessons_1 }),
                        byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                value: __assign(__assign({}, response.data), { lessons: sortedLessons_1 }),
                                loading: false,
                                error: undefined,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                value: __assign(__assign({}, response.data), { lessons: sortedLessons_1 }),
                                loading: false,
                                error: undefined,
                            },
                            _b),
                    });
                });
            }
            if (response.success === false) {
                // TODO add errors to by id or just move this to starndard context like everyother stufff
                setProgram(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: response })); });
            }
            return response;
        })
            .catch(function (error) {
            setProgram(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error })); });
            return error;
        });
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var fetchProgress = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "progress",
                mode: "value",
                fetchAction: courses_2.progress.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.progress) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setProgress,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchPaginatedProgress = (0, react_1.useCallback)(function (filter) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "progressPaginated/".concat(JSON.stringify(filter)),
                mode: "paginated",
                fetchAction: courses_2.progressPaginated.bind(null, apiUrl)(token, filter, {
                    signal: (_a = abortControllers.current["progressPaginated/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setPaginatedProgress,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchMyAuthoredCourses = (0, react_1.useCallback)(function (params) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "myAuthoredCourses/".concat(JSON.stringify(params)),
                mode: "paginated",
                fetchAction: courses_2.myAuthoredCourses.bind(null, apiUrl)(token, params, {
                    signal: (_a = abortControllers.current["myAuthoredCourses/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setMyAuthoredCourses,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchCourseProgress = (0, react_1.useCallback)(function (id) {
        if (!token) {
            return Promise.reject("noToken");
        }
        setCourseProgressDetails(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { byId: prevState.byId
                    ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = __assign(__assign({}, prevState.byId[id]), { loading: true }), _a)) : (_b = {}, _b[id] = { loading: true }, _b) }));
        });
        return courses_2.courseProgress
            .bind(null, apiUrl)(id, token)
            .then(function (response) {
            if (response.success) {
                setCourseProgressDetails(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), { loading: false, byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                value: response.data,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                value: response.data,
                                loading: false,
                            },
                            _b) }));
                });
            }
            if (response.success === false) {
                setCourseProgressDetails(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), { loading: false, byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                error: response,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                error: response,
                                loading: false,
                            },
                            _b) }));
                });
            }
        });
    }, [token]);
    var fetchTutor = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "tutor".concat(id),
            id: id,
            mode: "value",
            fetchAction: courses_2.tutor.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["tutor".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setTutor,
        });
    }, [token]);
    var fetchOrders = (0, react_1.useCallback)(function (params) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "orders/".concat(JSON.stringify(params)),
                mode: "paginated",
                fetchAction: cart_1.orders.bind(null, apiUrl)(token, params, {
                    signal: (_a = abortControllers.current["orders/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setOrders,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchPayments = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "payments",
                mode: "paginated",
                fetchAction: cart_1.payments.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setPayments,
            })
            : Promise.reject("noToken");
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var sendProgress = (0, react_1.useCallback)(function (courseId, data) {
        return token
            ? courses_2.sendProgress
                .bind(null, apiUrl)(courseId, data, token)
                .then(function (res) {
                setCourseProgressDetails(function (prevState) {
                    var _a;
                    return (__assign(__assign({}, prevState), { byId: __assign(__assign({}, prevState.byId), (_a = {}, _a[courseId] = res.success
                            ? {
                                loading: false,
                                value: res.data,
                            }
                            : {
                                loading: false,
                                error: res,
                            }, _a)) }));
                });
                setProgress(function (prevState) { return (__assign(__assign({}, prevState), { value: prevState && prevState.value
                        ? prevState.value.map(function (courseProgress) {
                            if (courseProgress.course.id === courseId) {
                                return __assign(__assign({}, courseProgress), { progress: courseProgress.progress.map(function (progress) {
                                        var el = data.find(function (item) { return item.topic_id === progress.topic_id; });
                                        if (el) {
                                            return el;
                                        }
                                        return progress;
                                    }) });
                            }
                            return courseProgress;
                        })
                        : [] })); });
            })
            : Promise.reject("noToken");
    }, [token]);
    // Refactor h5pProgress. Move to h5p `src/react/context/h5p.tsx`
    // https://github.com/EscolaLMS/sdk/issues/254
    var h5pProgress = (0, react_1.useCallback)(function (courseId, topicId, statement) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var statementId = (_a = statement === null || statement === void 0 ? void 0 : statement.verb) === null || _a === void 0 ? void 0 : _a.id;
        var statementCategory = (_c = (_b = statement === null || statement === void 0 ? void 0 : statement.context) === null || _b === void 0 ? void 0 : _b.contextActivities) === null || _c === void 0 ? void 0 : _c.category;
        var result = statement === null || statement === void 0 ? void 0 : statement.result;
        var hasParent = ((_e = (_d = statement === null || statement === void 0 ? void 0 : statement.context) === null || _d === void 0 ? void 0 : _d.contextActivities) === null || _e === void 0 ? void 0 : _e.parent) &&
            ((_h = (_g = (_f = statement === null || statement === void 0 ? void 0 : statement.context) === null || _f === void 0 ? void 0 : _f.contextActivities) === null || _g === void 0 ? void 0 : _g.parent) === null || _h === void 0 ? void 0 : _h.length) > 0;
        if (defaults_1.attempted === statementId &&
            statementCategory &&
            statementCategory[0].id.includes(defaults_1.guessTheAnswer)) {
            var pr = (0, exports.getCalcCourseProgress)(Number(courseId), progress, courseProgressDetails);
            sendProgress(Number(courseId), (pr === null || pr === void 0 ? void 0 : pr.map(function (prItem) {
                if (prItem.topic_id === topicId) {
                    return __assign(__assign({}, prItem), { status: API.CourseProgressItemElementStatus.COMPLETE });
                }
                return prItem;
            })) || [
                {
                    topic_id: topicId,
                    status: API.CourseProgressItemElementStatus.COMPLETE,
                },
            ]);
        }
        if (defaults_1.blackList.includes(statementId)) {
            return null;
        }
        if (defaults_1.completed.includes(statementId)) {
            if ((!hasParent &&
                statementCategory &&
                !((_j = statementCategory[0]) === null || _j === void 0 ? void 0 : _j.id.includes(defaults_1.questionSet))) ||
                (statementCategory &&
                    ((_k = statementCategory[0]) === null || _k === void 0 ? void 0 : _k.id.includes(defaults_1.questionSet)) &&
                    result &&
                    ((_l = result === null || result === void 0 ? void 0 : result.score) === null || _l === void 0 ? void 0 : _l.max) === ((_m = result === null || result === void 0 ? void 0 : result.score) === null || _m === void 0 ? void 0 : _m.raw))) {
                var pr = (0, exports.getCalcCourseProgress)(Number(courseId), progress, courseProgressDetails);
                sendProgress(Number(courseId), (pr === null || pr === void 0 ? void 0 : pr.map(function (prItem) {
                    if (prItem.topic_id === topicId) {
                        return __assign(__assign({}, prItem), { status: API.CourseProgressItemElementStatus.COMPLETE });
                    }
                    return prItem;
                })) || [
                    {
                        topic_id: topicId,
                        status: API.CourseProgressItemElementStatus.COMPLETE,
                    },
                ]);
            }
        }
        return token
            ? courses_2.h5pProgress.bind(null, apiUrl)(topicId, statementId, statement, token)
            : null;
    }, [token, progress, courseProgressDetails]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var topicPing = (0, react_1.useCallback)(function (topicId) {
        return token
            ? courses_2.topicPing
                .bind(null, apiUrl)(topicId, token)
                .catch(function (err) { return err; })
            : Promise.reject("noToken");
    }, [token]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var progressMap = (0, react_1.useMemo)(function () {
        var defaultMap = {
            coursesProcProgress: {},
            finishedTopics: [],
        };
        if (progress.value) {
            progress.value.reduce(function (acc, course) {
                acc.coursesProcProgress[typeof course.course.id === "number" ? course.course.id : 0] =
                    course.progress.reduce(function (sum, item) { return sum + item.status; }, 0) /
                        course.progress.length;
                acc.finishedTopics = acc.finishedTopics.concat(course.progress
                    .filter(function (item) {
                    return item.status === API.CourseProgressItemElementStatus.COMPLETE;
                })
                    .map(function (item) { return item.topic_id; }));
                return acc;
            }, defaultMap);
        }
        return defaultMap;
    }, [progress]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var topicIsFinished = (0, react_1.useCallback)(function (topicId) {
        if (progressMap && progressMap.finishedTopics.includes(topicId)) {
            return true;
        }
        // fetch by
        return false;
    }, [progressMap]);
    // https://github.com/EscolaLMS/sdk/issues/241
    var courseProgress = (0, react_1.useCallback)(function (courseId) {
        return progressMap && progressMap.coursesProcProgress[courseId]
            ? progressMap.coursesProcProgress[courseId]
            : 0;
    }, [progressMap]);
    // Refactored. Added getFlatTopics function with return flatted topics from lessons
    // https://github.com/EscolaLMS/sdk/issues/255
    var getNextPrevTopic = (0, react_1.useCallback)(function (topicId, next) {
        if (next === void 0) { next = true; }
        if (program.value === undefined) {
            return null;
        }
        var flatTopics = (0, course_1.getFlatTopics)(program.value.lessons);
        var currentTopicIndex = flatTopics === null || flatTopics === void 0 ? void 0 : flatTopics.findIndex(function (fTopic) { return fTopic.id === topicId; });
        if (currentTopicIndex === undefined || currentTopicIndex === -1) {
            return null;
        }
        if (next) {
            if (Array.isArray(flatTopics) && flatTopics[currentTopicIndex + 1]) {
                return flatTopics[currentTopicIndex + 1] || null;
            }
        }
        else {
            if (Array.isArray(flatTopics) && flatTopics[currentTopicIndex - 1]) {
                return flatTopics[currentTopicIndex - 1] || null;
            }
        }
        return null;
    }, [program]);
    // Refactor voucher. move to separate file
    // https://github.com/EscolaLMS/sdk/issues/256
    var realizeVoucher = (0, react_1.useCallback)(function (voucher) {
        return token
            ? cart_1.addVoucher
                .bind(null, apiUrl)(voucher, token)
                .finally(function () { return fetchCart(); })
            : Promise.reject("noToken");
    }, [token]);
    var removeVoucher = (0, react_1.useCallback)(function () {
        return token
            ? cart_1.removeVoucher
                .bind(null, apiUrl)(token)
                .finally(function () { return fetchCart(); })
            : Promise.reject("noToken");
    }, [token]);
    return ((0, jsx_runtime_1.jsx)(exports.EscolaLMSContext.Provider, __assign({ value: {
            confirmAccountDelete: confirmAccountDelete,
            initAccountDelete: initAccountDelete,
            token: token,
            apiUrl: apiUrl,
            courses: courses,
            course: course,
            program: program,
            fetchCourses: fetchCourses,
            fetchCourse: fetchCourse,
            fetchProgram: fetchProgram,
            fetchSettings: fetchSettings,
            settings: settings,
            config: config,
            fetchConfig: fetchConfig,
            fetchTags: fetchTags,
            uniqueTags: uniqueTags,
            fetchCategories: fetchCategories,
            categoryTree: categoryTree,
            login: login,
            logout: logout,
            forgot: forgot,
            reset: reset,
            user: user,
            register: register,
            fetchCart: fetchCart,
            addToCart: addToCart,
            removeFromCart: removeFromCart,
            resetCart: resetCart,
            cart: cart,
            payWithStripe: payWithStripe,
            fetchProgress: fetchProgress,
            fetchPaginatedProgress: fetchPaginatedProgress,
            paginatedProgress: paginatedProgress,
            fetchCourseProgress: fetchCourseProgress,
            progress: progress,
            courseProgressDetails: courseProgressDetails,
            sendProgress: sendProgress,
            fetchTutors: fetchTutors,
            tutors: tutors,
            fetchTutor: fetchTutor,
            tutor: tutor,
            fetchOrders: fetchOrders,
            orders: orders,
            fetchPayments: fetchPayments,
            payments: payments,
            pages: pages,
            fetchPages: fetchPages,
            page: page,
            fetchPage: fetchPage,
            fetchProfile: fetchProfile,
            updateProfile: updateProfile,
            updateProfileEmail: updateProfileEmail,
            updateAvatar: updateAvatar,
            topicPing: topicPing,
            topicIsFinished: topicIsFinished,
            courseProgress: courseProgress,
            getNextPrevTopic: getNextPrevTopic,
            h5pProgress: h5pProgress,
            userGroups: userGroups,
            fetchUserGroups: fetchUserGroups,
            userGroup: userGroup,
            fetchUserGroup: fetchUserGroup,
            registerableGroups: registerableGroups,
            fetchRegisterableGroups: fetchRegisterableGroups,
            socialAuthorize: socialAuthorize,
            notifications: notifications,
            fetchNotifications: fetchNotifications,
            readNotify: readNotify,
            readAllNotifications: readAllNotifications,
            certificates: certificates,
            fetchCertificates: fetchCertificates,
            fetchCertificate: fetchCertificate,
            generateCertificate: generateCertificate,
            mattermostChannels: mattermostChannels,
            fetchMattermostChannels: fetchMattermostChannels,
            h5p: h5p,
            fetchH5P: fetchH5P,
            emailVerify: emailVerify,
            getRefreshedToken: getRefreshedToken,
            tokenExpireDate: tokenExpireDate,
            fetchConsultations: fetchConsultations,
            consultations: consultations,
            consultation: consultation,
            fetchConsultation: fetchConsultation,
            fields: fields,
            fetchFields: fetchFields,
            stationaryEvents: stationaryEvents,
            fetchStationaryEvents: fetchStationaryEvents,
            fetchStationaryEvent: fetchStationaryEvent,
            fetchUserConsultations: fetchUserConsultations,
            userConsultations: userConsultations,
            bookConsultationTerm: bookConsultationTerm,
            fetchWebinars: fetchWebinars,
            fetchWebinar: fetchWebinar,
            webinars: webinars,
            payWithP24: payWithP24,
            subscriptionPayWithP24: subscriptionPayWithP24,
            getProductInfo: getProductInfo,
            fetchTutorConsultations: fetchTutorConsultations,
            approveConsultationTerm: approveConsultationTerm,
            generateConsultationJitsy: generateConsultationJitsy,
            rejectConsultationTerm: rejectConsultationTerm,
            tutorConsultations: tutorConsultations,
            fetchEvents: fetchEvents,
            events: events,
            changePassword: changePassword,
            deleteAccount: deleteAccount,
            stationaryEvent: stationaryEvent,
            webinar: webinar,
            userWebinars: userWebinars,
            userProducts: userProducts,
            fetchUserWebinars: fetchUserWebinars,
            generateWebinarJitsy: generateWebinarJitsy,
            realizeVoucher: realizeVoucher,
            removeVoucher: removeVoucher,
            products: products,
            product: product,
            fetchQuestionnaires: fetchQuestionnaires,
            fetchQuestionnaire: fetchQuestionnaire,
            fetchQuestionnairesAnswers: fetchQuestionnairesAnswers,
            fetchQuestionnaireStars: fetchQuestionnaireStars,
            fetchQuestionnaireStarsByModel: fetchQuestionnaireStarsByModel,
            sendQuestionnaireAnswer: sendQuestionnaireAnswer,
            fetchUserStationaryEvents: fetchUserStationaryEvents,
            userStationaryEvents: userStationaryEvents,
            fetchOrderInvoice: fetchOrderInvoice,
            addMissingProducts: addMissingProducts,
            getImagePrefix: getImagePrefix,
            getImageSvgPrefix: getImageSvgPrefix,
            changeConsultationTerm: changeConsultationTerm,
            fetchProducts: fetchProducts,
            fetchProduct: fetchProduct,
            fetchMyProducts: fetchMyProducts,
            attachProduct: attachProduct,
            cancelSubscription: cancelSubscription,
            courseAccess: courseAccess,
            fetchCourseAccess: fetchCourseAccess,
            addCourseAccess: addCourseAccess,
            deleteCourseAccess: deleteCourseAccess,
            myCourses: myCourses,
            fetchMyCourses: fetchMyCourses,
            fetchMyAuthoredCourses: fetchMyAuthoredCourses,
            myAuthoredCourses: myAuthoredCourses,
            challenges: challenges,
            fetchChallenges: fetchChallenges,
            challenge: challenge,
            fetchChallenge: fetchChallenge,
            consultationAccessEnquiry: consultationAccessEnquiry,
            fetchConsultationAccessEnquiry: fetchConsultationAccessEnquiry,
            consultationAccess: consultationAccess,
            fetchConsultationAccess: fetchConsultationAccess,
            addConsultationAccess: addConsultationAccess,
            deleteConsultationAccess: deleteConsultationAccess,
            updateConsultationAccess: updateConsultationAccess,
            tasks: tasks,
            fetchTasks: fetchTasks,
            addTask: addTask,
            deleteTask: deleteTask,
            task: task,
            fetchTask: fetchTask,
            updateTask: updateTask,
            updateTaskStatus: updateTaskStatus,
            createTaskNote: createTaskNote,
            updateTaskNote: updateTaskNote,
            deleteTaskNote: deleteTaskNote,
            bookmarkNotes: bookmarkNotes,
            createBookmarkNote: createBookmarkNote,
            updateBookmarkNote: updateBookmarkNote,
            deleteBookmarkNote: deleteBookmarkNote,
            fetchBookmarkNotes: fetchBookmarkNotes,
            fetchSubjects: fetchSubjects,
            subjects: subjects,
            fetchSchedule: fetchSchedule,
            schedule: schedule,
            fetchScheduleTutors: fetchScheduleTutors,
            scheduleTutors: scheduleTutors,
            fetchAttendances: fetchAttendances,
            attendances: attendances,
            fetchExams: fetchExams,
            exams: exams,
            createTeamsChat: createTeamsChat,
            fetchSemesters: fetchSemesters,
            semesters: semesters,
            fetchAcademicYears: fetchAcademicYears,
            academicYears: academicYears,
            dictionariesWords: dictionariesWords,
            fetchDictionariesWords: fetchDictionariesWords,
            dictionariesWord: dictionariesWord,
            fetchDictionariesWord: fetchDictionariesWord,
            dictionariesAccess: dictionariesAccess,
            fetchDictionariesAccess: fetchDictionariesAccess,
            dictionariesWordsCategories: dictionariesWordsCategories,
            fetchDictionariesWordsCategories: fetchDictionariesWordsCategories,
        } }, { children: children })));
};
var EscolaLMSContextProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var contextProps = {
        defaults: props.defaults,
        apiUrl: props.apiUrl,
        ssrHydration: props.ssrHydration,
    };
    var wrappers = [
        user_1.UserContextProvider,
        courses_3.CoursesContextProvider,
        categories_1.CategoriesContextProvider,
        tags_1.TagsContextProvider,
        tutors_1.TutorsContextProvider,
        webinars_2.WebinarsContextProvider,
        webinar_1.WebinarContextProvider,
        h5p_1.H5pContextProvider,
        consultations_2.ConsultationsContextProvider,
        pages_1.PagesContextProvider,
        page_1.PageContextProvider,
        consultations_access_1.ConsultationAccessContextProvider,
        consultations_access_enquiry_1.ConsultationAccessEnquiryContextProvider,
        notifications_1.NotificationsContextProvider,
        course_access_1.CourseAccessContextProvider,
        tasks_1.TasksContextProvider,
        task_1.TaskContextProvider,
        bookmark_notes_1.BookmarkNotesContextProvider,
        cart_2.CartContextProvider,
        questionnaires_1.QuestionnairesContextProvider,
        subjects_1.SubjectsContextProvider,
        schedule_1.ScheduleContextProvider,
        subjectsTutors_1.ScheduleTutorsContextProvider,
        attendances_1.AttendancesContextProvider,
        exams_1.ExamsContextProvider,
        studentDetails_1.StudentDetailsContextProvider,
        challenges_1.ChallengesContextProvider,
        dictionariesWords_1.DictionariesWordsContextProvider,
        dictionariesWord_1.DictionariesWordContextProvider,
        dictionariesAccess_1.DictionariesAccessContextProvider,
        dictionariesWordsCategories_1.DictionariesWordsCategoriesContextProvider,
    ].reverse();
    var C = wrappers.reduce(function (acc, curr, i) {
        return react_1.default.createElement(curr, contextProps, acc);
    }, react_1.default.createElement(EscolaLMSContextProviderInner, props, children));
    return C;
};
exports.EscolaLMSContextProvider = EscolaLMSContextProvider;
